<script lang="ts" setup>
defineProps({
    isSolid: {
        type: Boolean,
        default: false
    }
})
</script>

<template>
    <svg
        v-if="isSolid"
        xmlns="http://www.w3.org/2000/svg"
        class="fill-current"
        viewBox="0 0 24 24"
    >
        <path
            d="M10.5 3.5c0-.82843.6716-1.5 1.5-1.5s1.5.67157 1.5 1.5v4.56193l7.2079 5.46167c.499.3781.7921.9681.7921 1.5941v1.2244c0 .3726-.3929.6143-.7254.4463L13.5 13.1135v4.9506l2.0184 1.2235c.299.1813.4816.5056.4816.8552v1.3565c0 .3451-.3413.5864-.6667.4714L12 20.792l-3.33331 1.1787C8.34133 22.0857 8 21.8444 8 21.4993v-1.3565c0-.3496.18262-.6739.48162-.8552L10.5 18.0641v-4.9506l-7.27455 3.6749c-.33257.168-.72545-.0737-.72545-.4463v-1.2244c0-.626.29314-1.216.79212-1.5941L10.5 8.06193V3.5Z"
        />
    </svg>

    <svg
        v-else
        xmlns="http://www.w3.org/2000/svg"
        class="fill-current"
        viewBox="0 0 24 24"
    >
        <path
            fill-rule="evenodd"
            d="M9.5 4.52336C9.5 3.12945 10.619 2 12 2s2.5 1.12945 2.5 2.52336v3.03737l6.8 5.14767c.755.5723 1.2 1.4696 1.2 2.4224v1.2021c0 1.1254-1.174 1.8572-2.171 1.3546L14.5 14.7452v1.7414l1.529.9256c.602.3654.971 1.0224.971 1.731v1.3414c0 1.0437-1.02 1.7734-1.996 1.4292L12 20.852l-3.004 1.0618C8.02 22.258 7 21.5283 7 20.4846v-1.3414c0-.7086.369-1.3656.971-1.731l1.529-.9256v-1.7414l-5.829 2.9423c-.998.5026-2.171-.2292-2.171-1.3546v-1.2021c0-.9528.445-1.8501 1.2-2.4224l6.8-5.14767V4.52336Zm-6 10.99304 8-4.0374v6.1502L9 19.1432v.6308l3-1.0598 3 1.0598v-.6308l-2.5-1.514V11.479l8 4.0374v-.3856c0-.3179-.148-.6167-.4-.8075l-7.6-5.75323V4.52336c0-.27858-.224-.50467-.5-.50467s-.5.22609-.5.50467v4.04671L3.9 14.3233c-.252.1908-.4.4896-.4.8075v.3856Z"
            clip-rule="evenodd"
        />
    </svg>
</template>
